export default {
    BUILDING_CONSTRUCTION: 'wwfort_entered_foundation_state',
    BUILDING_UPGRADED: 'wwfort_upgrade_building',
    BUILDING_CLICK: 'wwbuilding_click',
    BUTTON_CLICK: 'wwyes_01',
    CANCEL_CLICK: 'wwselect_radial_button', // ID: 3348025780
    CAROUSEL_HOVER: 'wwcarousel_01',
    CAROUSEL_CLICK: 'wwcarousel_02',
    CLICK: 'wwplay_01', // ID: 1256202815
    COINS: 'wwspend_credits',
    HOVER: 'wwhighlight_02', // ID: 3174665583
    MODERNIZATION_HOVER: 'wwhighlight_02', // TODO: replace with original sound when it's ready
    MODERNIZATION_CLICK: 'wwplay_01', // TODO: replace with original sound when it's ready
    RESERVE_ACTIVATION: 'wwactivate_requisition',
    RESERVE_PRODUCE_START: 'wwfort_order_inprogress',
    RESERVE_PRODUCE_SUCCESS: 'wwfort_order_isready',
    SELECT_CLICK: 'wwyes1', // ID: 2374742115
    SELECT_BATTLE_CLICK: 'wwtransport_approve',
    TAB_CLICK: 'wwtabb', // ID: 3005416308
}



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/sounds.js